/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { BuilderUserContext } from '@gh/builder-shared';
import { CloneUsingPriceBookType, SystemVarsSalesRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { OfficeData } from '@gh/common-shared-data';

import { combineLatest, Observable } from 'rxjs';
import { SystemVarsSales, systemVarsSalesFromDto } from './model/system-vars-sales.model';
import { map$ } from '@gh/rx/operators';

@Injectable()
export class SystemVarsSalesBusinessService implements InitViewService {
  private office: OfficeData;

  constructor(private restService: SystemVarsSalesRestService,
              private userContext: BuilderUserContext,
              private dictionaryService: DictionaryService) {
    this.office = <OfficeData>this.userContext.office;
  }

  initView(): any {
    return {
      sysVarsSales: this.restService.get().pipe(map$(systemVarsSalesFromDto)),
      websiteLeads: this.restService.getWebsiteLeads(),
      cloneUsingPriceBookTypes: this.dictionaryService.getByEnum(CloneUsingPriceBookType),
    };
  }

  update(sysVarsSales: SystemVarsSales, websiteLeads: any): Observable<any> {
    return combineLatest(this.restService.update(sysVarsSales),
      this.restService.updateWebsiteLeads({
        assignees: websiteLeads,
      })).pipe(map$(([res1, res2]) => ({
      sysVarsSales: systemVarsSalesFromDto(res1),
      websiteLeads: res2,
    })));
  }
}
